<template>
  <div>
    <a
      @click="openPasswordResetDialog"
      :loading="processing"
      class="fw-500 pointer"
    >
      {{ $bct('Forgot password?') }}
    </a>

    <ResourceDialog
      @cancel="closePasswordResetDialog()"
      @save="sendPasswordReset()"
      ref="confirmPasswordResetDialog"
      :content="$route.query.email_sent_to"
      :fields="passwordResetFields"
      :processing="processing"
      cancel-button-text="Cancel"
      save-button-text="Confirm and send"
      title="Send password to:"
    />
  </div>
</template>

<script setup>
import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';
import useApi from '@/shared/composables/useApi';
import useEventBus from '@/shared/composables/useEventBus';

const { api } = useApi();
const eventBus = useEventBus();
const $bct = inject('translator');

const props = defineProps({
  scope: {
    type: String,
    default: null,
  },
});

const passwordResetFields = [{ value: 'email' }];
const processing = ref(null);
const confirmPasswordResetDialog = ref(null);

function openPasswordResetDialog() {
  return confirmPasswordResetDialog.value?.open();
}

function closePasswordResetDialog() {
  return confirmPasswordResetDialog.value?.close();
}

async function sendPasswordReset() {
  const email = confirmPasswordResetDialog.value.getLocalValue().email;
  if (!validateEmail(email)) return;

  processing.value = true;
  const resp = await api.member.passwordReset({ email, scope: props.scope });
  processing.value = null;
  closePasswordResetDialog();
  if (resp.status !== 200) return;

  eventBus.chime(`An email with password reset instructions has been sent to ${email}`);
}

function validateEmail(email) {
  if (!email) {
    eventBus.error('Email is a required field');
    return false;
  }

  return true;
}
</script>
